import { useState } from 'react';

import PropTypes from 'prop-types';
import { BsCheckCircle } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import TextInput from '#globalComponents/Forms/TextInput';

/**
 * Name the list and open it. The prospect query exists since the first buy; saving renames it.
 */
const SaveBlock = ({ defaultName, saved, onSave, saving }) => {
	const [name, setName] = useState(defaultName);
	if (saved) {
		return (
			<div className="flex items-center gap-2 text-sm text-success-700">
				<BsCheckCircle className="h-4 w-4" />
				Gespeichert als „{saved.name}“ – die Liste ist jetzt geöffnet.
			</div>
		);
	}
	return (
		<div className="rounded-card border border-bgBase-500 bg-white p-3.5">
			<label htmlFor="agent-save-name" className="mb-1.5 block text-xs-head">
				Als Suchanfrage speichern
			</label>
			<div className="flex gap-2">
				<TextInput
					id="agent-save-name"
					value={name}
					maxLength={120}
					onChange={(e) => setName(e.target.value)}
					className="flex-1"
				/>
				<Button onClick={() => onSave(name.trim() || defaultName)} loading={saving}>
					Speichern &amp; öffnen
				</Button>
			</div>
			<p className="mt-2 text-xs text-bgBase-800">
				Danach wie gewohnt: Kontaktlisten, Anreicherung, KI-Analyse, Export.
			</p>
		</div>
	);
};

SaveBlock.propTypes = {
	defaultName: PropTypes.string.isRequired,
	saved: PropTypes.shape({ name: PropTypes.string }),
	onSave: PropTypes.func.isRequired,
	saving: PropTypes.bool,
};

export default SaveBlock;
